import { api } from "@/services/api"

type UpdatePasswordRequest = {
  password: string
}

export const updatePassword = async (
  params: UpdatePasswordRequest
) => {
  await api.post("/beepaidgo/users/me/password/", {
    body: params,
  })
}
